import togglesTemplates from './togglesTemplates';

import {
  Default,
  WithBackground,
} from './togglesLayouts';

const togglesSet = [
  {
    component: Default,
    codeTemplate: togglesTemplates.noText,
    optionsGroup: [
      {
        label: 'No text',
        options: [
          {label: 'light', type: 'radio', options: {bgColor: null, darkBg: false}},
          {label: 'dark', type: 'radio', options: {bgColor: 'black', darkBg: true}},
        ]
      },
    ]
  },
  {
    component: WithBackground,
    codeTemplate: togglesTemplates.exception,
    previewClass: 'no-padding',
    optionsGroup: [
      {
        label: 'Exception',
        options: [
          {label: 'default', type: 'radio', options: {greenBg: true}},
        ]
      },
    ]
  },
  {
    component: Default,
    codeTemplate: togglesTemplates.withText,
    optionsGroup: [
      {
        label: 'With text',
        options: [
          {label: 'label', type: 'radio', options: {label: 'label', withSideLabel: false, withStatusLabel: false}},
          {label: 'with side label', type: 'radio', options: {label: 'side label', withSideLabel: true, withStatusLabel: false}},
          {label: 'Label + On/Off', type: 'radio', options: {label: '', withStatusLabel: true}},
        ]
      },
    ]
  },
];

export default togglesSet;



// WEBPACK FOOTER //
// ./src/containers/elements/Toggles/constants/togglesSet.js